/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_A3Inputs */

const en_guide_json_rest_api_faq_a3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send minified JSON over the wire to save bandwidth, since machines do not care about whitespace. Formatting is for humans, so pretty print only when you are reading or debugging a response.`)
};

const ko_guide_json_rest_api_faq_a3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전송 시에는 대역폭을 아끼기 위해 압축된 JSON을 보내세요. 기계는 공백에 신경 쓰지 않습니다. 포맷은 사람을 위한 것이니 응답을 읽거나 디버깅할 때만 보기 좋게 정리하세요.`)
};

const ja_guide_json_rest_api_faq_a3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転送時は帯域を節約するため圧縮した JSON を送りましょう。機械は空白を気にしません。整形は人のためのものなので、レスポンスを読んだりデバッグしたりするときだけ見やすくします。`)
};

/**
* | output |
* | --- |
* | "Send minified JSON over the wire to save bandwidth, since machines do not care about whitespace. Formatting is for humans, so pretty print only when you are ..." |
*
* @param {Guide_Json_Rest_Api_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_a3 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_a3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_a3(inputs)
	return ja_guide_json_rest_api_faq_a3(inputs)
});